<div class="container-tag-prime-gift">
  <div class="tag">
    <i aria-hidden="true" class="icon-prime"></i>
    <span> {{ 'PRIME_GIFT' | transloco }}</span>
  </div>
  <div class="gift">
    <span>{{ giftCopy }}</span>
  </div>
</div>